import { DSButton } from "@components/design-system/molecules";
import {
  faArrowLeft,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function OnboardingNavButtons({
  hideBack,
  hideNext,
  onBack,
  onNext,
  nextText = "Next",
  backText = "Back",
  disableBack,
  disableNext,
}) {
  return (
    <div className="flex flex-wrap gap-4 md:gap-8 w-full max-w-[90vw] justify-center">
      {!hideBack && (
        <DSButton
          variant="secondary"
          onClick={onBack}
          disabled={disableBack}
          dataTestId="back-step"
          size="lg"
          icon={faArrowLeft}
        >
          {backText}
        </DSButton>
      )}
      {!hideNext && (
        <DSButton
          variant={
            nextText === "Next" || nextText === "Finish"
              ? "primary"
              : "cancel"
          }
          onClick={onNext}
          disabled={disableNext}
          dataTestId="next-step"
          size="lg"
        >
          <span>{nextText}</span>
          <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
        </DSButton>
      )}
    </div>
  );
}
